import haronLogo from "./icons/on_sahp_agri_logo.png";
import tresemmeLogo from "./icons/tresemme-seeklogo.png";
import addspayLogo from "./icons/Screenshot 2026-03-03 225130.png";
import theMarkHotelLogo from "./icons/Screenshot 2026-03-03 230108.png";

export const ClientsSection = () => {
  const clients = [
    { name: "HARON INDIA", logo: haronLogo },
    { name: "ADDSPAY", logo: addspayLogo }, // using Tresemme logo as placeholder for testing
    { name: "TRESSEME", logo: tresemmeLogo },
    { name: "THE MARK HOTEL", logo: theMarkHotelLogo }, // using Tresemme logo as placeholder for testing
    // { name: "Apple", logo: tresemmeLogo }, // using Tresemme logo as placeholder for testing
  ];

  return (
    <section className="py-20 relative border-y border-border/50 px-4 sm:px-6 lg:px-8 xl:px-12">
      <div className="container mx-auto">
        {/* Header */}
        <div className="text-center mb-12">
          <p className="text-sm text-muted-foreground uppercase tracking-widest font-medium">
            Trusted by industry leaders
          </p>
        </div>

        {/* Infinite scrolling logos */}
        <div className="relative overflow-hidden">
          <div className="absolute left-0 top-0 bottom-0 w-24 md:w-32 bg-gradient-to-r from-background to-transparent z-10 pointer-events-none" />
          <div className="absolute right-0 top-0 bottom-0 w-24 md:w-32 bg-gradient-to-l from-background to-transparent z-10 pointer-events-none" />
          <div className="flex gap-12 animate-scroll w-max">
            {[...clients, ...clients].map((client, index) => (
              <div
                key={`${client.name}-${index}`}
                className="flex-shrink-0 flex items-center gap-3 px-6 py-4 rounded-xl glass hover:bg-primary/5 transition-colors cursor-pointer group"
              >
                <div className="w-10 h-10 rounded-lg bg-gradient-to-br from-muted to-muted/50 flex items-center justify-center font-heading font-bold text-lg group-hover:from-primary/20 group-hover:to-accent/20 transition-all">
                  <img
                    src={client.logo}
                    alt={`${client.name} logo`}
                    className="w-8 h-8 object-contain"
                  />
                </div>
                <span className="text-muted-foreground font-medium group-hover:text-foreground transition-colors whitespace-nowrap">
                  {client.name}
                </span>
              </div>
            ))}
          </div>
        </div>

        {/* Stats */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mt-16">

         
          {[
            { value: "20+", label: "Active Clients" },
            { value: "10+", label: "Enterprise Clients" },
            { value: "99.9%", label: "Uptime SLA" },
            { value: "5+", label: "Countries" },
          ].map((stat) => (
            <div key={stat.label} className="text-center group cursor-pointer">
              <div className="text-4xl md:text-5xl font-heading font-bold gradient-text group-hover:scale-110 transition-transform inline-block">
                {stat.value}
              </div>
              <div className="text-sm text-muted-foreground mt-2">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
